<div class="panel panel-default" style="margin-top: 0px;" *ngIf="contextVariables$ | async as contextVariables">
  <div class="panel-body" style="padding: 12px 12px 0px 12px;" *ngIf="templateParameters$ | async as templateParameters">
    <div>
      <p-tabView (onChange)="selectedTab($event)" [activeIndex]="tabIndex">
        <p-tabPanel header="Email" *ngIf="previewMediaType === 'email' || previewMediaType === undefined">
          <ng-template pTemplate="content">
            <email-message-new [mailContent]="contentResponse.mailContent"
                               [templateParameters]="templateParameters"
                               [templateUpdateModel]="templateUpdateModel"
                               [isOnlyPreview]="isOnlyPreview"
                               [userPermissions]="userPermissions"
                               [communicationsCategoryId]="communicationsCategoryId"
                               [tabIndex]="tabIndex"
                               [contextVariables]="contextVariables"
                               [triggeredCategory]="triggeredCategory"
                               [imageModel]="(previewEditTemplate$ | async).imageModel"
                               *ngIf="contentResponse$ | async as contentResponse else loading"
            ></email-message-new>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Sms" *ngIf="previewMediaType === 'sms' || previewMediaType === undefined">
          <ng-template pTemplate="content">
          <sms-message-new
                           [templateParameters]="templateParameters"
                           [isOnlyPreview]="isOnlyPreview"
                           [updatedModel]="templateUpdateModel.updatedModel"
                           [userPermissions]="userPermissions"
                           [contextVariables]="contextVariables"
                           [communicationsCategoryId]="communicationsCategoryId"
                           [tabIndex]="tabIndex"
                           [disablePasteEvent]="disablePasteEvent"
                           [triggeredCategory]="triggeredCategory"
                           *ngIf="contentResponse$ | async as contentResponse else loading"
          ></sms-message-new>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Voice" *ngIf="previewMediaType === 'voice' || previewMediaType === undefined">
          <ng-template pTemplate="content">
            <voice-message-new
                [templateParameters]="templateParameters"
                [isOnlyPreview]="isOnlyPreview"
                [voiceContent]="contentResponse.voiceContent"
                [updatedModel]="templateUpdateModel.updatedModel"
                [userPermissions]="userPermissions"
                [communicationsCategoryId]="communicationsCategoryId"
                [tabIndex]="tabIndex"
                [triggeredCategory]="triggeredCategory"
                *ngIf="contentResponse$ | async as contentResponse  else loading"
            ></voice-message-new>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
      <ng-template #loading>
        <img src="img/loading.gif" />
      </ng-template>
    </div>
  </div>
</div>
